import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addFaqsFailure,
  //
  addFaqsSuccess,
  deleteFaqsFailure,
  //
  deleteFaqsSuccess,
  editFaqsFailure,
  //
  editFaqsSuccess,
  fetchFaqs as fetchFaqsAction,
  fetchFaqsFailure,
  fetchFaqsSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_FAQS,
  DELETE_FAQS,
  EDIT_FAQS,
  FETCH_FAQS,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchFaqsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/faqs?${query}`);
    yield put(fetchFaqsSuccess(data));
  } catch (e) {
    yield put(fetchFaqsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching faqs!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/faqs/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addFaqsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/faqs/add`, payload.data);
    if (data) {
      yield put(successAlert("Faq added successfully!"));
      yield put(addFaqsSuccess());
      if (payload?.history) {
        payload.history.push(`/d/location/edit/${payload?.id}/faqs`);
      }
    }
  } catch (e) {
    yield put(addFaqsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editFaqsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/faqs/edit/${payload.data.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Faq updated successfully!"));
      yield put(editFaqsSuccess());
      yield put(getViewDataAction(payload.data.id));
    }
  } catch (e) {
    yield put(editFaqsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteFaqsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/faqs/${payload?.id}`);
    if (data) {
      yield put(successAlert("Faq deleted successfully!"));
      yield put(deleteFaqsSuccess());
      yield put(
        fetchFaqsAction({
          page: 1,
          limit: 10,
          location_id: payload?.location_id,
        })
      );
    }
  } catch (e) {
    yield put(deleteFaqsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchFaqsFlow() {
  yield takeEvery(FETCH_FAQS, fetchFaqsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addFaqsFlow() {
  yield takeEvery(ADD_FAQS, addFaqsSaga);
}
export function* editFaqsFlow() {
  yield takeEvery(EDIT_FAQS, editFaqsSaga);
}
export function* deleteFaqsFlow() {
  yield takeEvery(DELETE_FAQS, deleteFaqsSaga);
}

export default function* FaqsSaga() {
  yield all([
    fetchFaqsFlow(),
    addFaqsFlow(),
    editFaqsFlow(),
    deleteFaqsFlow(),
    getViewDataFlow(),
  ]);
}
